
export const CLASSES_SCRIPTS = [
    {
        id: "aula-teorica",
        title: { pt: "Introdução de Aula Teórica", en: "Theoretical Lecture Intro", es: "Introducción de Clase Teórica" },
        tags: ["Aulas", "Educação", "Curso"],
        content: {
            pt: `<r>BOAS VINDAS</r>
Olá alunos, sejam bem-vindos à aula de número [NÚMERO].
Hoje nós vamos mergulhar fundo no tema: [TEMA DA AULA].
<y>OBJETIVO DA AULA</r>
O meu objetivo hoje é que você saia daqui dominando [CONCEITO CHAVE].
Parece complicado agora, mas eu vou simplificar tudo em [NÚMERO] passos.
<y>AGENDA</r>
1. Primeiro, vamos definir [CONCEITO 1].
2. Depois, vamos analisar [ESTUDO DE CASO].
3. E por fim, vamos praticar com [EXERCÍCIO].
<g>INSTRUÇÃO</r>
Peguem seus cadernos e desliguem as notificações.
Vamos começar?`,
            en: `<r>WELCOME</r>
Hello students, welcome to class number [NUMBER].
Today we are going to dive deep into the topic: [CLASS TOPIC].
<y>CLASS GOAL</r>
My goal today is for you to leave here mastering [KEY CONCEPT].
It seems complicated now, but I will simplify everything in [NUMBER] steps.
<y>AGENDA</r>
1. First, we will define [CONCEPT 1].
2. Then, we will analyze [CASE STUDY].
3. And finally, we will practice with [EXERCISE].
<g>INSTRUCTION</r>
Grab your notebooks and turn off notifications.
Shall we start?`,
            es: `<r>BIENVENIDA</r>
Hola alumnos, bienvenidos a la clase número [NÚMERO].
Hoy vamos a profundizar en el tema: [TEMA DE LA CLASE].
<y>OBJETIVO DE LA CLASE</r>
Mi objetivo hoy es que salgas de aquí dominando [CONCEPTO CLAVE].
Parece complicado ahora, pero voy a simplificar todo en [NÚMERO] pasos.
<y>AGENDA</r>
1. Primero, definiremos [CONCEPTO 1].
2. Luego, analizaremos [ESTUDIO DE CASO].
3. Y finalmente, practicaremos con [EJERCICIO].
<g>INSTRUCCIÓN</r>
Tomen sus cuadernos y apaguen las notificaciones.
¿Empezamos?`
        }
    },
    {
        id: "curso-boas-vindas",
        title: { pt: "Boas-vindas ao Curso", en: "Course Welcome", es: "Bienvenida al Curso" },
        tags: ["Aulas", "Onboarding", "Curso"],
        content: {
            pt: `<r>PARABÉNS</r>
Parabéns pela decisão de entrar no [NOME DO CURSO].
Você acaba de dar um passo enorme em direção a [OBJETIVO].
Eu sou [SEU NOME] e serei seu guia nessa jornada.
<y>O QUE ESPERAR</r>
Nos próximos módulos, você vai aprender [HABILIDADE 1], [HABILIDADE 2] e [HABILIDADE 3].
Esqueça tudo que você já viu sobre [VELHO MÉTODO]. Aqui é diferente.
<y>COMO ESTUDAR</r>
Para ter o melhor aproveitamento:
- Assista na ordem.
- Faça os exercícios.
- Entre na comunidade.
<g>PRIMEIRO PASSO</r>
Seu primeiro desafio é simples: vá até o módulo 1 e assista a aula "Start".
Estou muito feliz de ter você aqui. Vamos voar!`,
            en: `<r>CONGRATULATIONS</r>
Congratulations on deciding to join [COURSE NAME].
You just took a huge step towards [GOAL].
I'm [YOUR NAME] and I will be your guide on this journey.
<y>WHAT TO EXPECT</r>
In the next modules, you will learn [SKILL 1], [SKILL 2] and [SKILL 3].
Forget everything you've seen about [OLD METHOD]. Here is different.
<y>HOW TO STUDY</r>
To get the most out of it:
- Watch in order.
- Do the exercises.
- Join the community.
<g>FIRST STEP</r>
Your first challenge is simple: go to module 1 and watch the "Start" class.
I'm very happy to have you here. Let's fly!`,
            es: `<r>FELICITACIONES</r>
Felicitaciones por la decisión de entrar al [NOMBRE DEL CURSO].
Acabas de dar un paso enorme hacia [OBJETIVO].
Soy [TU NOMBRE] y seré tu guía en esta jornada.
<y>QUÉ ESPERAR</r>
En los próximos módulos, aprenderás [HABILIDAD 1], [HABILIDAD 2] y [HABILIDAD 3].
Olvida todo lo que has visto sobre [VIEJO MÉTODO]. Aquí es diferente.
<y>CÓMO ESTUDIAR</r>
Para aprovechar al máximo:
- Mira en orden.
- Haz los ejercicios.
- Entra en la comunidad.
<g>PRIMER PASO</r>
Tu primer desafío es simple: ve al módulo 1 y mira la clase "Start".
Estoy muy feliz de tenerte aquí. ¡A volar!`
        }
    },
    {
        id: "aula-resumo-modulo",
        title: { pt: "Resumo do Módulo", en: "Module Summary", es: "Resumen del Módulo" },
        tags: ["Aulas", "Recap", "Educação"],
        content: {
            pt: `<r>INTRO</r>
Chegamos ao fim do Módulo [NÚMERO].
Foi uma jornada intensa, não foi?
Vamos recapitular os pontos principais para fixar.
<y>RECAP</r>
Neste módulo, nós vimos que:
1. [PONTO A] é fundamental para [RESULTADO A].
2. Nunca devemos [ERRO] quando estamos fazendo [AÇÃO].
3. O segredo está em [DETALHE].
<y>IMPORTÂNCIA</r>
Entender isso é crucial porque no próximo módulo vamos subir de nível.
Sem essa base, você não vai conseguir [PRÓXIMO PASSO].
<g>TAREFA</r>
Antes de avançar, certifique-se de ter completado o exercício [NOME].
Te vejo no próximo nível.`,
            en: `<r>INTRO</r>
We have reached the end of Module [NUMBER].
It was an intense journey, wasn't it?
Let's recap the main points to solidify.
<y>RECAP</r>
In this module, we saw that:
1. [POINT A] is fundamental to [RESULT A].
2. We must never [MISTAKE] when we are doing [ACTION].
3. The secret lies in [DETAIL].
<y>IMPORTANCE</r>
Understanding this is crucial because in the next module we will level up.
Without this foundation, you won't be able to [NEXT STEP].
<g>TASK</r>
Before moving forward, make sure you have completed exercise [NAME].
See you at the next level.`,
            es: `<r>INTRO</r>
Llegamos al final del Módulo [NÚMERO].
Fue una jornada intensa, ¿verdad?
Recapitulemos los puntos principales para fijar.
<y>RECAP</r>
En este módulo, vimos que:
1. [PUNTO A] es fundamental para [RESULTADO A].
2. Nunca debemos [ERROR] cuando estamos haciendo [ACCIÓN].
3. El secreto está en [DETALLE].
<y>IMPORTANCIA</r>
Entender esto es crucial porque en el próximo módulo subiremos de nivel.
Sin esta base, no podrás [PRÓXIMO PASO].
<g>TAREA</r>
Antes de avanzar, asegúrate de haber completado el ejercicio [NOMBRE].
Nos vemos en el próximo nivel.`
        }
    },
    {
        id: "aula-explicacao-tarefa",
        title: { pt: "Explicação de Tarefa/Atividade", en: "Assignment Explanation", es: "Explicación de Tarea" },
        tags: ["Aulas", "Exercício", "Instrução"],
        content: {
            pt: `<r>O DESAFIO</r>
Agora é hora de colocar a mão na massa.
Teoria sem prática é apenas informação, não conhecimento.
<y>INSTRUÇÕES</r>
Sua tarefa é criar [PROJETO] usando a técnica [TÉCNICA].
Siga estes passos:
1. Abra o arquivo [MODELO].
2. Preencha os campos com [DADOS].
3. Salve e envie na plataforma.
<y>DICA DE OURO</r>
Preste atenção no [DETALHE ESPECÍFICO], é onde a maioria erra.
Use o checklist que eu deixei em anexo.
<g>PRAZO</r>
Vocês têm até [DATA] para entregar.
Bom trabalho!`,
            en: `<r>THE CHALLENGE</r>
Now it's time to get your hands dirty.
Theory without practice is just information, not knowledge.
<y>INSTRUCTIONS</r>
Your task is to create [PROJECT] using the [TECHNIQUE] technique.
Follow these steps:
1. Open the [TEMPLATE] file.
2. Fill in the fields with [DATA].
3. Save and submit on the platform.
<y>GOLDEN TIP</r>
Pay attention to [SPECIFIC DETAIL], that's where most people get it wrong.
Use the checklist I left attached.
<g>DEADLINE</r>
You have until [DATE] to submit.
Good work!`,
            es: `<r>EL DESAFÍO</r>
Ahora es hora de poner manos a la obra.
Teoría sin práctica es solo información, no conocimiento.
<y>INSTRUCCIONES</r>
Tu tarea es crear [PROYECTO] usando la técnica [TÉCNICA].
Sigue estos pasos:
1. Abre el archivo [MODELO].
2. Rellena los campos con [DATOS].
3. Guarda y envía en la plataforma.
<y>CONSEJO DE ORO</r>
Presta atención al [DETALLE ESPECÍFICO], es donde la mayoría se equivoca.
Usa el checklist que dejé adjunto.
<g>PLAZO</r>
Tienen hasta el [FECHA] para entregar.
¡Buen trabajo!`
        }
    },
    {
        id: "aula-estudo-caso",
        title: { pt: "Análise de Estudo de Caso", en: "Case Study Analysis", es: "Análisis de Estudio de Caso" },
        tags: ["Aulas", "Análise", "Exemplo"],
        content: {
            pt: `<r>INTRODUÇÃO</r>
Hoje vamos analisar o caso da empresa/pessoa [NOME].
Eles saíram de [SITUAÇÃO DEPLORÁVEL] para [SUCESSO TOTAL] em apenas [TEMPO].
Como? Usando a estratégia [ESTRATÉGIA].
<y>ANÁLISE - MOMENTO 1</r>
No início, o problema principal era [PROBLEMA].
Eles tentaram resolver com [SOLUÇÃO ERRADA] e falharam.
<y>A VIRADA</r>
Foi quando a liderança decidiu implementar [MUDANÇA].
Isso gerou um impacto imediato em [MÉTRICA].
<y>LIÇÃO</r>
O que podemos aprender com isso?
1. Não tenha medo de [AÇÃO].
2. Foque sempre em [FOCO].
<g>CONCLUSÃO</r>
Agora, como você pode aplicar isso no seu contexto?
Pense nisso até a próxima aula.`,
            en: `<r>INTRODUCTION</r>
Today we are going to analyze the case of company/person [NAME].
They went from [BAD SITUATION] to [TOTAL SUCCESS] in just [TIME].
How? Using the [STRATEGY] strategy.
<y>ANALYSIS - MOMENT 1</r>
In the beginning, the main problem was [PROBLEM].
They tried to solve it with [WRONG SOLUTION] and failed.
<y>THE TURNING POINT</r>
That was when leadership decided to implement [CHANGE].
This generated an immediate impact on [METRIC].
<y>LESSON</r>
What can we learn from this?
1. Don't be afraid to [ACTION].
2. Always focus on [FOCUS].
<g>CONCLUSION</r>
Now, how can you apply this in your context?
Think about this until the next class.`,
            es: `<r>INTRODUCCIÓN</r>
Hoy vamos a analizar el caso de la empresa/persona [NOMBRE].
Pasaron de [SITUACIÓN DEPLORABLE] a [ÉXITO TOTAL] en solo [TIEMPO].
¿Cómo? Usando la estrategia [ESTRATEGIA].
<y>ANÁLISIS - MOMENTO 1</r>
Al principio, el problema principal era [PROBLEMA].
Intentaron resolverlo con [SOLUCIÓN EQUIVOCADA] y fallaron.
<y>EL CAMBIO</r>
Fue cuando el liderazgo decidió implementar [CAMBIO].
Esto generó un impacto inmediato en [MÉTRICA].
<y>LECCIÓN</r>
¿Qué podemos aprender de esto?
1. No tengas miedo de [ACCIÓN].
2. Enfócate siempre en [FOCO].
<g>CONCLUSIÓN</r>
Ahora, ¿cómo puedes aplicar esto en tu contexto?
Piénsalo hasta la próxima clase.`
        }
    }
];
